const { ASYNC, SIMPLE } = require('../utils/redux-helpers');

module.exports = {
    MARK_READ: ASYNC,
    MARK_OFFER_NOTIFICATIONS_READ: SIMPLE,
    CLEAR_MENTIONS: ASYNC,
    ACCEPT: ASYNC,
    ACCEPT_TRANSFER: ASYNC,
    DECLINE: ASYNC,
    DISMISS: ASYNC,
    DISMISS_OFFER_NOTIFICATIONS: SIMPLE,
    ANSWER_QUESTION: ASYNC,
    UPDATE_SCHEDULED_NOTIFICATION_STATUS: ASYNC,
    DELETE_SCHEDULED_NOTIFICATION: ASYNC
};